<script>
    import InstallExtensionButtons from "$/components/ctas/InstallExtensionButtons.svelte";
    import StartAddingSnippetsButtons from "$/components/ctas/StartAddingSnippetsButtons.svelte";
    import { onMount } from "svelte";
    import { checkIfExtensionInstalled } from "$/utils/Utils";
    import ZeroSnippetsImg from "$/images/error/0-Snippets.png";
    import NoExtensionImg from "$/images/error/No-Extension.png";
    import DesktopRecommendationImg from "$/images/error/Mobile-Desktop-Recommendation.png";

    export let type;
    let isExtensionInstalled = true;
    let isDesktop = true;

    const updateImageDisplay = () => {
        isDesktop = window.innerWidth >= 768;
    };

    onMount(async () => {
        isExtensionInstalled = await checkIfExtensionInstalled();

        updateImageDisplay();
        window.addEventListener("resize", updateImageDisplay);
        return () => window.removeEventListener("resize", updateImageDisplay);
    });
</script>

<div class="empty-state">
    {#if type === "topic"}
        <div class="empty-state__text_wrapper">
            <span
                >No topics yet. Go to Collabwriting Extension and start adding
                topics 😊</span
            >
            <InstallExtensionButtons />
        </div>
    {:else if type === "snippet"}
        <div class="empty-state__text_wrapper">
            {#if isExtensionInstalled}
                <img src={ZeroSnippetsImg} alt="No snippets yet." />
                <StartAddingSnippetsButtons />
            {:else}
                {#if isDesktop}
                    <img
                        src={NoExtensionImg}
                        alt="Go to Collabwriting Extension and start adding snippets 😊"
                    />
                    <StartAddingSnippetsButtons />
                {:else}
                    <img
                        src={DesktopRecommendationImg}
                        alt="Use the desktop version for a better experience 😊"
                    />
                {/if}
                <InstallExtensionButtons />
                <span class="description"
                    >Install the Collabwriting Extension, and start adding
                    snippets 😊</span
                >
            {/if}
        </div>
    {:else if type === "snippet_filter"}
        <div class="empty-state__text_wrapper">
            <span
                >No snippets with selected filter. Try using a different filter
                😊</span
            >
        </div>
    {/if}
</div>

<style>
    @import "../../main.css";

    .empty-state {
        @apply reset flex h-full w-full flex-col items-center justify-center text-white !important;
    }

    .empty-state img {
        @apply reset h-auto w-full object-contain sm:h-auto sm:w-full !important;
    }

    .empty-state__text_wrapper {
        @apply reset mt-8 flex w-full max-w-sm flex-col items-center gap-2 pb-24 text-center text-base text-black !important;
    }

    .empty-state__text_wrapper a {
        @apply reset font-bold hover:underline hover:decoration-pink-600 hover:decoration-2 !important;
    }

    .empty-state__text_wrapper span {
        @apply reset text-xs !important;
    }

    .description {
        @apply text-center text-base text-gray-800;
    }
</style>
